export default {
    en: "English",
    it: "Italian",
    es: "Spanish"
  }